import { render, staticRenderFns } from "./introductoryArticle.vue?vue&type=template&id=36f7119e&scoped=true"
import script from "./introductoryArticle.vue?vue&type=script&lang=js"
export * from "./introductoryArticle.vue?vue&type=script&lang=js"
import style0 from "./introductoryArticle.vue?vue&type=style&index=0&id=36f7119e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f7119e",
  null
  
)

export default component.exports